const evalErrCodes = (errCodes, error) => {
  if (typeof error === "object" && error.code) {
    return errCodes.some(err => err.includes(error.code));
  }
  return false;
};

// Depending on the err text, should the browser reload the MFA screen?
export const mfaReloadPage = error => {
  const errCodes = ["NotAuthorizedException"];
  const errTxt = (error === null || error === void 0 ? void 0 : error.message) || error;
  return errTxt.includes("Invalid session for the user") && evalErrCodes(errCodes, error);
};

// On the certain errors, just disable further MFA verification process
export const mfaFreezeVerification = error => {
  const errCodes = ["LimitExceededException", "TooManyRequestsException", "NotAuthorizedException"];
  return evalErrCodes(errCodes, error);
};